/* eslint-disable import/prefer-default-export,max-len,radix */
import { wtsApi } from 'src/api';
import { toastrNetworkError } from 'src/helpers/toastr/toastrNetworkResponse';
import toastrError from 'src/helpers/toastr/toastrError';
import communicate from 'src/api/communicate';
export const REQUEST = 'LOAD_DEVICES_REQUEST';
export const SUCCESS = 'LOAD_DEVICES_SUCCESS';
export const FAIL = 'LOAD_DEVICES_FAIL';
export const OPTIONS_SUCCESS = 'LOAD_DEVICES_OPTIONS_SUCCESS';
export const GET_SIMPLE_REGISTRATORS_SUCCESS = 'GET_SIMPLE_REGISTRATORS_SUCCESS';
export const PUT_SIMPLE_REGISTRATORS_SUCCESS = 'PUT_SIMPLE_REGISTRATORS_SUCCESS';
const loadDevicesSuccess = (jobs) => ({ type: SUCCESS, jobs });
const loadDevicesRequest = () => ({ type: REQUEST });
const loadDevicesFail = (error) => ({ type: FAIL, error });
const loadDevicesOptionsSuccess = (jobs) => ({ type: OPTIONS_SUCCESS, jobs });
const getSimpleRegistratorsSuccess = (simpleRegistrators) => ({ type: GET_SIMPLE_REGISTRATORS_SUCCESS, simpleRegistrators });
const putSimpleRegistratorsSuccess = (simpleRegistrator) => ({ type: PUT_SIMPLE_REGISTRATORS_SUCCESS, simpleRegistrator });
const reformatDevicesForOptionsMenu = (data) => data.map((device) => ({
    value: device.DeviceId.toString(),
    label: device.Location
}));
export const loadDevices = () => (dispatch) => {
    dispatch(loadDevicesRequest());
    return communicate({ url: 'Devices?deviceTypeIds=2,4', method: 'get' }).then((response) => {
        dispatch(loadDevicesSuccess(response.data.Data));
        dispatch(loadDevicesOptionsSuccess(reformatDevicesForOptionsMenu(response.data.Data)));
    }).catch((err) => {
        dispatch(loadDevicesFail(err));
        toastrError(err);
    });
};
export const loadSimpleRegistrators = () => async (dispatch) => {
    try {
        const response = await wtsApi.v2.simpleRegistratorSearchCreate({ PageSize: -1 });
        dispatch(getSimpleRegistratorsSuccess(response.data.Data));
        return response.data.Data;
    }
    catch (err) {
        toastrNetworkError(err);
        return await Promise.reject(err);
    }
};
export const putSimpleRegistrator = (simpleRegistrator) => async (dispatch) => {
    try {
        const response = await wtsApi.v2.simpleRegistratorUpdateUpdate(simpleRegistrator);
        dispatch(putSimpleRegistratorsSuccess(response.data.Data));
        return response.data.Data;
    }
    catch (err) {
        toastrNetworkError(err);
        return await Promise.reject(err);
    }
};
export const putSimpleRegistratorSecret = (query) => async () => {
    try {
        const response = await wtsApi.v2.simpleRegistratorClientSecretUpdate(query);
        return response.data;
    }
    catch (err) {
        toastrNetworkError(err);
        return await Promise.reject(err);
    }
};
